import {
  Directive,
  ElementRef,
  Input,
  OnInit,
  Renderer2,
  ComponentFactoryResolver,
  ViewContainerRef,
} from '@angular/core';
import { ComponentMapperService } from './services/component-mapper.service';

@Directive({
  selector: '[appLazyLoad]',
})
export class LazyLoadDirective implements OnInit {
  @Input('appLazyLoad') componentName!: string;
  @Input() threshold: number = 200;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private viewContainer: ViewContainerRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    private componentMapper: ComponentMapperService
  ) {}

  ngOnInit() {
    this.renderer.listen('window', 'scroll', () => {
      if (this.isNearView()) {
        this.loadComponent();
      }
    });
  }

  isNearView(): boolean {
    const rect = this.el.nativeElement.getBoundingClientRect();
    return rect.top - this.threshold < window.innerHeight && rect.bottom > 0;
  }

  loadComponent() {
    if (this.viewContainer.length === 0) {
      const componentFactory =
        this.componentFactoryResolver.resolveComponentFactory(
          this.componentMapper.getComponent(this.componentName)
        );
      this.viewContainer.createComponent(componentFactory);
    }
  }
}
